import { Provider } from '@angular/core';
import { of } from 'rxjs';
import { ManagementService } from '../auth/management.service';

function buildMockManagementServiceDefaults(): Partial<ManagementService> {
  return {
    user$: of(undefined),
  };
}

export function MockManagementServiceProvider(
  overrides: Partial<ManagementService> = {}
): Provider {
  return {
    provide: ManagementService,
    useValue: {
      ...buildMockManagementServiceDefaults(),
      ...overrides,
    },
  };
}
